import NiceModal from '@ebay/nice-modal-react';
import dynamic from 'next/dynamic';
import type { LoginModalProps } from './login-modal';

// 使用 dynamic 导出 default，保持按需加载（仅客户端渲染）
export default dynamic(() => import('./login-modal'), { ssr: false });

export const LOGIN_MODAL = 'app-login-modal';

let isRegistered = false;

async function ensureModalRegistered() {
  if (isRegistered) return;
  const modalModule = await import('./login-modal');
  NiceModal.register(LOGIN_MODAL, modalModule.default);
  isRegistered = true;
}

export const registerLoginModal = async () => {
  await ensureModalRegistered();
};

/**
 * 显示登录模态框（按需加载）
 * 
 * 仅在需要展示时，才动态加载和注册组件，减少首屏体积。
 */
export const showLoginModal = async (params?: LoginModalProps) => {
  await ensureModalRegistered();
  return NiceModal.show(LOGIN_MODAL, params);
};

export const hideLoginModal = () => {
  NiceModal.hide(LOGIN_MODAL);
};
